import React from "react";
import { Row, Col } from "reactstrap";

import HyperDelta from "components/HyperDrive/HyperDelta";
import CargoDrones from "components/HyperDrive/CargoDrones";

const ConceptStudy = ({isMobile}) => {
  return (
    <>
      <h2 className="text-center title" style={{ color: "white", marginTop: '20px', marginBottom: '20px', fontWeight: 'bolder' }}>Concept Studies</h2>
      { /* Text */ }
      <p className="text-center" style={{ color: "white", fontSize: '1.25em', marginBottom: '10px', paddingLeft:isMobile ? '0em':'3.5em', paddingRight:isMobile ? '0em':'3.5em'}}>
      MagLev Aero maintains in-house engineering and design expertise to help tailor thruster systems to meet your unique needs. 
      Specialists in aerodynamics, aeromechanics, aeroacoustics, and electrodynamics will work with your design team to maximize the performance of your vehicle.
      </p>
      <CargoDrones isMobile={isMobile} />
      <HyperDelta isMobile={isMobile} />
    </>
  );
};

export default ConceptStudy;
